import { render, staticRenderFns } from "./modal-tos-confirm.vue?vue&type=template&id=6458aa96"
import script from "./modal-tos-confirm.vue?vue&type=script&lang=js"
export * from "./modal-tos-confirm.vue?vue&type=script&lang=js"
import style0 from "./modal-tos-confirm.vue?vue&type=style&index=0&id=6458aa96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports